// API Configuration
const apiBaseUrlOverride = process.env.REACT_APP_API_BASE_URL?.replace(/\/$/, '');

const API_CONFIG = {
  development: {
    baseURL: apiBaseUrlOverride || 'http://localhost:5000'
  },
  production: {
    baseURL: apiBaseUrlOverride || 'https://h8uxrf3ps4.execute-api.us-east-1.amazonaws.com/prod'
  }
};

// Get current environment
const getEnvironment = () => {
  if (process.env.NODE_ENV === 'production') {
    return 'production';
  }
  return 'development';
};

// Get API base URL
export const getApiBaseUrl = () => {
  const env = getEnvironment();
  return API_CONFIG[env].baseURL;
};

// API endpoints
export const API_ENDPOINTS = {
  health: '/api/health',
  referral: '/api/referral',
  slackInteractive: '/api/slack/interactive',
  // Authentication endpoints
  login: '/api/auth/login',
  googleLogin: '/api/auth/google-login',
  changePassword: '/api/auth/change-password',
  // Admin endpoints
  adminStats: '/api/admin/stats',
  adminLeads: '/api/admin/leads',
  adminUpdateLead: '/api/admin/leads'
};

// Full API URLs
export const getApiUrl = (endpoint) => {
  return `${getApiBaseUrl()}${endpoint}`;
};

const apiConfig = {
  getApiBaseUrl,
  getApiUrl,
  API_ENDPOINTS
};

export default apiConfig;
